import CryptoAes from "crypto-js/aes";
import CryptoEncUtf8 from "crypto-js/enc-utf8";

const CryptoSalt = "qJ21VQGgzV2VuAgCPvULbxgVa7HhTap";

export function encrypt(value) {
  return CryptoAes.encrypt(value, CryptoSalt).toString();
}

export function decrypt(encrypted) {
  return CryptoAes.decrypt(encrypted, CryptoSalt).toString(CryptoEncUtf8);
}

/**
 * This function is same as PHP's nl2br() with default parameters.
 *
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML
 * @return {string} Filtered text
 */
export function nl2br(str, replaceMode = true, isXhtml = true) {
  if (!str) {
    return null;
  }
  var breakTag = isXhtml ? "<br />" : "<br>";
  var replaceStr = replaceMode ? "$1" + breakTag : "$1" + breakTag + "$2";
  return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}
